import * as fromAdmCamposC from '../../../actions/AdmSiicart/Modelos/admCamposC.actions';

export interface AdmCamposCState {
  Procesando: boolean;
  Respuesta: any;
  ErrorMessage: any | null;
}

export const initialState: AdmCamposCState = {
    Procesando: false,
    Respuesta: null,
    ErrorMessage: null
  };

export function admCamposCReducer(state = initialState, action: fromAdmCamposC.AdmCamposCAcciones): AdmCamposCState {
    switch (action.type) {
      case fromAdmCamposC.AdmCamposCActionTypes.GET_ADM_CAMPOSC: {
        return {
          ...state,
          Procesando: true,
          Respuesta: null,
          ErrorMessage: null
        };
      }
      case fromAdmCamposC.AdmCamposCActionTypes.SUCESS_CAMPOSC: {
        return {
          ...state,
          Procesando: false,
          Respuesta: action.Respuesta,
          ErrorMessage: null
        };
      }
      case fromAdmCamposC.AdmCamposCActionTypes.FAIL_CAMPOSC: {
        return {
            ...state,
            Procesando: false,
            Respuesta: null,
            ErrorMessage: {...action.Respuesta}
        };
      }
      default: {
        return state;
      }
    }
  }
